// NOTE: hooks
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { toast } from 'sonner'
import { useAuth } from '../../hooks/useAuth'
import { useFormik } from 'formik'
import { ResetPwdValidation } from './authValidation'

const useDataResetPwd = () => {
	const [urlParams] = useSearchParams()
	const [loadingResetPassword, setLoadingResetPassword] = useState(false)
	const { resetPwd } = useAuth()

	// NOTE: send email with token to reset password
	const handleResetPwd = async (email: string) => {
		setLoadingResetPassword(true)

		const url = `${window.location.protocol}//${window.location.host}${urlParams.get(
			'redirect'
		)}?resetPwd=true&email=${email}`

		const response = await resetPwd(email, url)

		const json = await response.json()

		if (!response.ok) {
			toast.error(json.error)
			setLoadingResetPassword(false)
			return
		}

		toast.success(`Check your ${email} inbox and follow the link to reset your password. Check your spam if it has not landed in your inbox.`, { duration: Infinity })

		// TODO: remove this in prod
		/*console.log(
			'https://ethereal.email/message/' + json.response.split(' ')[3].replace('MSGID=', '')
		)*/

		setLoadingResetPassword(false)
	}

	// NOTE: hook to use formik in a custom form
	const { values, errors, touched, handleChange, handleSubmit, handleBlur } = useFormik({
		initialValues: {
			email: ''
		},
		validationSchema: ResetPwdValidation,
		onSubmit: (values, { setSubmitting }) => {
			handleResetPwd(values.email)
			setSubmitting(false)
		}
	})

	return {
		handleResetPwd,
		loadingResetPassword,
		values,
		errors,
		touched,
		handleChange,
		handleSubmit,
		handleBlur
	}
}
export default useDataResetPwd
